import React from "react";
import Grid from '@mui/material/Grid2';
import { ExternalTicket } from "@services/tickets/types";
import { Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import ConsoleLog from "@pages/Tickets/ConsoleLog";
import Typography from "@common/components/Typography";
import { displayDateTime } from "@common/utils/localTime.utils";

type TalServiceNowProps = {
  externalTicket: ExternalTicket;
};

const TalServiceNow = (props: TalServiceNowProps) => {
  const { t } = useTranslation();
  const { externalTicket } = props;

  const compareName = (a: [string, string], b: [string, string]) => {
    return a[0].localeCompare(b[0]);
  };

  const convertLineBreak = (text: string) => {
    return text.split("\n").map((line, i) => (
      <span key={`line-${i}`}>
        {line}
        <br />
      </span>
    ));
  };

  const serviceNowToDisplay = () => {
    if (externalTicket.extraProperties) {
      return Object.entries(externalTicket.extraProperties)
        .sort(compareName)
        .map(([key, value]) => {
          if (key === "link") return;
          const val =
            key === "datetimeOpen" ||
            key === "datetimeClosed" ||
            key === "datetimeAssigned" ||
            key === "datetimeSynced"
              ? displayDateTime(parseInt(value))
              : value;

          return (
            <Grid key={key}>
              <Grid
                container
                spacing={2}
                sx={{ width: '100%', flexWrap: "nowrap", }}
              >
                <Grid
                  size={{
                    md: 4
                  }}>
                  <ConsoleLog>
                    <Typography realTime>{t(key)}</Typography>
                  </ConsoleLog>
                </Grid>
                <Grid
                  sx={{
                    flex: "1",
                  }}>
                  <Typography
                    realTime
                    sx={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {convertLineBreak(val)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        });
    }
    return <></>;
  };

  return (
    <Grid
      container
      spacing={2}
      sx={(theme) => ({
        padding: theme.spacing(2, 4),
        flexDirection: "column",
      })}
    >
      <Grid>
        <Grid>{externalTicket.source}</Grid>
      </Grid>
      <Grid>
        <Grid
          container
          spacing={1}
          sx={{ width: '100%', flexDirection: "column", }}
        >
          {serviceNowToDisplay()}
          <Grid>
            {externalTicket.link && (
              <Link href={externalTicket.link} target="_blank">
                {t("Open this case in {{ source }}...", {
                  source: externalTicket.source,
                })}
              </Link>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TalServiceNow;
function displayDatetime(value: string) {
  throw new Error("Function not implemented.");
}
